export default __webpack_public_path__ + "static/media/home_3.0fbb1974.svg";